export function between(val: number, from: number, to: number) {
    return Math.min(Math.max(val, from), to);
}

export function formatWithSpaces(numberStr: number | string) {
    return numberStr.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function getNumber(value: unknown, defaultValue: number | (() => number)) {
    return typeof value === 'number' && !isNaN(value)
        ? value
        : (
            typeof defaultValue === 'number'
                ? defaultValue
                : defaultValue()
        );
}

export function randomInt(num: number) {
    return Math.floor(Math.random() * num);
}

export const enum NumberPlural {
    ONE = 0,
    SOME = 1,
    MANY = 2
}

export interface ReducedNumber {
    formatted: FormattedReducedNumber;
    plural: NumberPlural;
}

export type FormattedReducedNumber = number | `${string | number}K` | `${string | number}M`;

// 1300 -> 1.3К
export function reduceNumber(value: number): ReducedNumber {
    if (value < 1_000) {
        return {
            formatted: value,
            plural: extractPlural(value)
        };
    }

    if (value < 1_000_000) {
        const numberOfThousands = (value / 1_000).toFixed(1);

        return {
            formatted: `${removeExtraZero(numberOfThousands)}K`,
            plural: NumberPlural.MANY
        };
    }

    const numberOfMillions = (value / 1_000_000).toFixed(1);

    return {
        formatted: `${removeExtraZero(numberOfMillions)}M`,
        plural: NumberPlural.MANY
    };
}

export function extractPlural(value: number): NumberPlural {
    const penultimateDigit = Math.floor((value % 100) / 10);
    if (penultimateDigit === 1) {
        return NumberPlural.MANY;
    }
    const lastDigit = value % 10;
    if (lastDigit === 1) {
        return NumberPlural.ONE;
    }
    if (lastDigit >= 2 && lastDigit <= 4) {
        return NumberPlural.SOME;
    }
    return NumberPlural.MANY;
}

function removeExtraZero(num: string) {
    if (num.endsWith('0')) {
        return num.substring(0, num.length - 2);
    }

    return num;
}
